<template>
  <div class="ticketList">
    <div class="ticketList-title">
      <div>额度说明</div>
      <div>每家企业默认发放服务券额度为<span>10000元</span></div>
      <div>上年度新升规企业服务券发放额度<span>20000元</span></div>
      <div>丽水市专精特新“小巨人”种苗企业库企业服务券发放额度<span>10000元</span></div>
    </div>
    <div class="top-Batch">
      <template>
        <div v-if="upCouponLatest">
          <div class="name">{{ upCouponLatest.couponName }}</div>
          <div class="batch-amount">
            ¥
            <!-- <span class="price">{{
              upCouponLatest.totalMoney.toLocaleString()
            }}</span> -->
            <span class="price">5,000,000</span>
          </div>
          <div class="batch-time">
            使用时间：{{ upCouponLatest.couponStartTime }} 至
            {{ upCouponLatest.couponEndTime }}
          </div>
        </div>
      </template>
      <template v-if="!upCouponLatest">
        <div class="notStarted">服务券未开始开放</div>
        <div class="wait">请在发放时间再来看看吧！</div>
      </template>
    </div>
    <div class="ticketList-coupon">
      <!-- <div>
        <div>{{ upCouponLatest.singleServiceCoupon || '-' }}</div>
        <div>可抢券金额(元)</div>
      </div> -->
      <div>
        <div>{{ upCouponLatest.couponAmount || '-' }}</div>
        <div>单次可抢金额(元)</div>
      </div>
      <div>
        <div style="font-weight:700;font-size:26px;">
          {{
            upCouponLatest.restCouponChance == null ||
            upCouponLatest.restCouponChance == undefined
              ? '-'
              : upCouponLatest.restCouponChance
          }}
        </div>
        <div>剩余抢券机会(次)</div>
      </div>
    </div>
    <div class="ticketList-ticket" v-if="isEntTime">
      抢券倒计时
      <span>{{ timeList.hours }}</span>
      :
      <span>{{ timeList.minutes }}</span>
      :
      <span>{{ timeList.seconds }}</span>
    </div>
    <div class="ticketList-ticket1" v-if="!isEntTime && couponRestStatus == 0">
      <img src="@/assets/images/naozhong.png" alt="" />
      抢券中
    </div>
    <div class="ticketList-ticket1" v-if="!isEntTime && couponRestStatus == 1">
      <img src="@/assets/images/yiqiangwang.png" alt="" />
      已抢完
    </div>
    <div class="ticketList-ul">
      <div
        class="ticketList-ul-li"
        v-for="(item, index) in ticket"
        :key="index"
        @click="getCoupons(item)"
      >
        <img :src="imgList[index]" alt="" />
        <b>{{ item.serviceType === '智能化数字化服务' ? '智能化数字化':item.serviceType }}</b>
        <!-- <div
          :class="[
            'surplus',
            isEntTime || item.disabled === 1 ? 'surplus-time' : ''
          ]"
        >
          剩余 <span>¥{{ item.remainMoney }}</span>
        </div> -->
        <div class="progress-line">
          <div class="progress"></div>
          <div
            :class="[
              'speed',
              isEntTime || item.disabled === 1 ? 'speed-time' : ''
            ]"
            :style="{
              width:
                item.totalMoney - item.remainMoney === 0
                  ? 100 + '%'
                  : (item.remainMoney / item.totalMoney) * 100 + '%'
            }"
          ></div>
        </div>
        <!-- item.remainMoney > 0 ||  -->
        <div
          v-if="item.disabled !== 1"
          :class="['receive', isEntTime ? 'receive-time' : '']"
        >
          立即领取
        </div>
        <div v-else class="receive received">抢完了</div>
      </div>
    </div>
    <van-popup
      closeable
      v-model="isShow"
      :style="{ height: '380px', width: '80%' }"
    >
      <div class="popup-coupons">
        <i></i>
        <b>领取成功</b>
        <div class="popup-type">
          <span>服务券类型：</span><span>{{ popupList.typeName }}</span>
        </div>
        <div class="popup-type">
          <span>面值：</span><span>{{ popupList.couponMoney }}元</span>
        </div>
        <div class="receive">
          领取的服务券可在<span>“我的服务券”</span>中查看
        </div>
        <div class="popup-btn" @click="linkTap($event)">去查看</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  insertOrCoupon,
  couponTypeList,
  findCouponInfo,
  findCurrentTime
} from '@api/coupons/index'
import { Toast, Dialog } from 'vant'
import { getLocalStorage, setLocalStorage } from '@utils'
import MSG from './components/msg'
export default {
  name: 'GrabATicket',
  data() {
    return {
      upCouponLatest: { couponAmount: '' }, // 上架的服务券批次
      ticket: [],
      entTime: '',
      timeList: {
        days: '',
        hours: '00',
        minutes: '00',
        seconds: '00'
      },
      timingTime: '',
      isShow: false,
      popupList: {},
      isEntTime: false,
      distribute: getLocalStorage('couponsId'),
      imgList: [
        require('../../../assets/enterprise/coupons/rlzy.png'),
        require('../../../assets/enterprise/coupons/jscx.png'),
        require('../../../assets/enterprise/coupons/cssj.png'),
        require('../../../assets/enterprise/coupons/flwq.png'),
        require('../../../assets/enterprise/coupons/sckz.png'),
        require('../../../assets/enterprise/coupons/tyq.png'),
        require('../../../assets/enterprise/coupons/zscq.png'),
        require('../../../assets/enterprise/coupons/cyfw.png'),
        require('../../../assets/enterprise/coupons/xxhfw.png'),
        require('../../../assets/enterprise/coupons/pxfw.png'),
        require('../../../assets/enterprise/coupons/qt.png'),
        require('../../../assets/enterprise/coupons/glzx.png')
      ],
      couponRestStatus: '',
      time1: null,
      time2: null
    }
  },
  created() {
    findCurrentTime().then(res => {
      if (res.data.code == '0000') {
        this.time1 = res.data.data
        this.time2 = res.data.data
        this.getcCuponTypeList()
      }
    })
  },
  mounted() {
    this.couponBatch()
  },
  methods: {
    getCoupons(row) {
      if (this.isEntTime || row.disabled === 1) {
        return
      }
      Dialog.confirm({
        title: '服务券领取确认',
        width: '283px',
        confirmButtonColor: '#49a9f0',
        message: `是否确认领取 "${row.serviceType}" 服务券`
      })
        .then(() => {
          // on confirm
          const params = {
            couponId: row.couponId,
            couponTypeName: row.serviceType
          }
          insertOrCoupon(params).then(res => {
            const { code, data, msg } = res.data
            if (code === '0000') {
              // Toast('领取成功')
              this.couponBatch()
              this.popupList = data
              this.isShow = true
              this.getcCuponTypeList()
            } else {
              Toast(msg)
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    linkTap() {
      this.$emit('dateUp', 2)
      MSG.$emit('dateUp', 2)
    },
    // 服务类型列表
    getcCuponTypeList(id) {
      couponTypeList({ id: this.distribute }).then(res => {
        const { code, data, msg } = res.data
        if (code === '0000') {
          this.ticket = data.typeList
          this.couponRestStatus = data.couponRestStatus
          if (data.serviceCoupon) {
            this.entTime = data.serviceCoupon.couponStartTime
            var the = new Date(this.entTime.replace(/-/g, '/')).getTime()
            var date = this.time2
            console.log(the)
            console.log(date)
            if (the > date) {
              this.loveTime()
              this.isEntTime = true
              this.timingTime = setInterval(() => {
                this.loveTime()
              }, 1000)
            }
          } else {
            this.isEntTime = false
          }
        } else {
          Toast(msg)
        }
      })
    },
    // 时间倒计时
    loveTime() {
      var the = new Date(this.entTime.replace(/-/g, '/')).getTime()
      // var date = new Date().getTime()
      var date = this.time1
      var time = (the - date) / 1000
      var d = parseInt(time / (60 * 60 * 24))
      var h = parseInt((time / 60 / 60) % 24)
      var m = parseInt((time / 60) % 60)
      var s = parseInt(time % 60)
      // console.log(d + '天' + h + '小时' + m + '分钟' + s + '秒')
      if (h === 0) {
        h == 0
        if (m === 0) {
          m == 0
          if (s === 0) {
            s == 0
            clearInterval(this.timingTime)
            this.isEntTime = false
          }
        }
      }
      this.timeList.hours = h < 10 ? '0' + h : h // 时
      this.timeList.minutes = m < 10 ? '0' + m : m // 分
      this.timeList.seconds = s < 10 ? '0' + s : s // 秒
      this.time1 = this.time1 + 1000
    },
    // 批次
    couponBatch() {
      findCouponInfo().then(res => {
        const { code, data, msg } = res.data
        if (code === '0000') {
          if (data.upCouponLatest) {
            this.upCouponLatest = data.upCouponLatest
            // MSG.$emit('val', data.upCouponLatest.couponStartTime)
            // setLocalStorage('couponsId', this.upCouponLatest.id)
            this.upCouponLatest.couponStartTime = this.timeHandle(
              this.upCouponLatest.couponStartTime
            )
            this.upCouponLatest.couponEndTime = this.timeHandle(
              this.upCouponLatest.couponEndTime
            )
          } else {
            MSG.$emit('val', false)
          }
          if (data.entCouponList) {
            this.entCouponList = data.entCouponList.map((value, index) => {
              const lent = value.entName.split('').length
              // if (lent > 9) {
              value.entName =
                value.entName.substr(0, 2) +
                '...' +
                value.entName.substr(lent - 4)
              // }
              return value
            })
          }
          if (data.entLatestCoupon) {
            this.entLatestCoupon = data.entLatestCoupon
          }
        }
      })
    },
    // 时间处理
    timeHandle(m) {
      const time = m.split(' ')[0]
      const days = time.split('-')
      return days[0] + '年' + days[1] + '月' + days[2] + '日'
    }
  }
}
</script>

<style lang="scss" scoped>
.ticketList {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100%;
  padding: 10px 15px 0;
  background-color: #f3f8ff;
  overflow: scroll;
  padding-bottom: 53px;
  background: url('../../../assets/enterprise/coupons/homeBg.png') no-repeat;
  background-size: 100%;
  &-title {
    padding: 14px 15px;
    font-size: 16px;
    border-radius: 2px;
    color: rgba(102, 102, 102, 100);
    margin: 16px auto 20px;
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 0.95);
    & > div:nth-child(1) {
      font-size: 16px;
      color: rgba(51, 51, 51, 100);
      font-weight: 600;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      &::before {
        width: 4px;
        height: 16px;
        content: '';
        display: inline-block;
        border-radius: 2px;
        background-color: rgba(0, 112, 255, 1);
        margin-right: 5px;
      }
    }
    span {
      color: rgb(28, 128, 254);
    }
  }
  .top-Batch {
    padding: 0 0 15px;
    color: rgba(255, 255, 255, 100);
    .name {
      font-size: 18px;
    }
    .batch-amount {
      padding: 8px 0 10px;
      .price {
        font-size: 34px;
      }
    }
    .batch-time {
      font-size: 14px;
    }
    .notStarted {
      font-size: 28px;
    }
    .wait {
      font-size: 16px;
      margin: 5px 0 10px;
    }
  }
  &-coupon {
    display: flex;
    font-size: 12px;
    padding: 24px 12px 28px;
    color: rgba(255, 255, 255, 0.95);
    border-radius: 5px;
    margin-bottom: 16px;
    background: linear-gradient(to bottom, #00f1ff, #304eff);
    > div {
      text-align: center;
      width: 50%;
      > div:nth-child(1) {
        line-height: 28px;
        color: rgba(255, 255, 255, 100);
        font-size: 20px;
      }
    }
  }
  &-ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    width: 350px;
    margin: 0 auto 80px;
    &-li {
      width: 100px;
      height: 159px;
      padding-left: 9px;
      background-color: #fff;
      border-radius: 5px;
      margin-right: 2%;
      margin-bottom: 12px;

      img {
        width: 30px;
        height: 30px;
        margin-top: 12px;
      }
      b {
        display: block;
        color: rgba(0, 0, 0, 0.85);
        font-size: 15px;
        margin-top: 4px;
      }
      .surplus {
        color: rgba(0, 0, 0, 0.65);
        font-size: 13px;
        margin-top: 10px;
        span {
          color: rgba(255, 29, 29, 100);
        }
      }
      .surplus-time {
        span {
          color: rgba(51, 51, 51, 100);
        }
      }
      .progress-line {
        position: relative;
        margin-top: 5px;
        width: 90.5px;
        > div {
          width: 90px;
          height: 3px;
          border-radius: 2px;
          margin: 4px 0 12px 0;
          background-color: rgba(228, 228, 228, 1);
        }
        .speed {
          position: absolute;
          top: -4px;
          left: 0;
          background-color: rgba(255, 29, 29, 1);
        }
        .speed-time {
          background-color: #747474;
        }
      }

      .receive {
        width: 91px;
        height: 28px;
        line-height: 28px;
        color: rgba(0, 128, 255, 100);
        font-size: 14px;
        border-radius: 5px;
        background-color: rgba(0, 128, 255, 0.1);
        border: 1px solid rgba(0, 128, 255, 0.3);
        text-align: center;
      }
      .receive-time {
        color: rgba(51, 51, 51, 100);
        background-color: rgba(0, 0, 0, 0.1);
        border: none;
      }

      .received {
        border: none;
        color: rgba(51, 51, 51, 100);
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
    &-li:nth-child(3n) {
      margin-right: 0;
    }
  }
  &-ul::after {
    content: '';
    width: 100px;
  }
  &-ticket {
    text-align: center;
    font-size: 18px;
    color: #ff7f00;
    margin: 16px 0;
    span {
      display: inline-block;
      width: 34px;
      height: 36px;
      line-height: 36px;
      border-radius: 2px;
      background-color: rgba(255, 255, 255, 1);
    }
  }
  &-ticket1 {
    color: #ff7f00;
    font-weight: 600;
    font-size: 26px;
    margin: 16px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      margin-right: 10px;
      width: 60px;
      height: 60px;
    }
  }
  .popup-coupons {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: url('../../../assets/enterprise/coupons/popup.png') no-repeat;
    background-size: 100%;
    text-align: center;
    i {
      display: block;
      width: 75px;
      height: 75px;
      background: url('../../../assets/zj-sh4.png') no-repeat;
      background-size: 100%;
      margin: 40px auto 14px;
    }
    b {
      display: block;
      color: rgba(0, 0, 0, 1);
      font-size: 18px;
      margin-bottom: 30px;
    }
    .popup-type {
      color: rgba(0, 0, 0, 0.65);
      font-size: 15px;
      display: flex;
      justify-content: space-between;
      margin: 8px 20px;
    }
    .receive {
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      margin: 25px auto 10px;
      span {
        color: #57acfe;
        font-weight: 550;
      }
    }
    .popup-btn {
      width: 90%;
      height: 41px;
      line-height: 41px;
      color: #fff;
      text-align: center;
      border-radius: 5px;
      font-size: 16px;
      background: linear-gradient(90deg, #0070ff 0%, #0060ff 100%);
      margin: 15px auto;
      letter-spacing: 1px;
    }
  }
}
</style>
